import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import "./TransactionFilterModal.scss";
import Close from "../../images/close-light.svg";
import { TransactionAuditCities } from "../../util/API/Compliance";

function TransactionFilterModal({ open, handleClose, setFilteredTransaction }) {
  const [cities, setCities] = useState([]);
  const [newCity, setNewCity] = useState("");

  const addCity = () => {
    if (cities.length >= 5) return;

    if (newCity.trim() !== "") {
      setCities([...cities, newCity.trim()]);
      setNewCity("");
    }
  };

  const removeCity = (cityToRemove) => {
    const updatedCities = cities.filter((city) => city !== cityToRemove);
    setCities(updatedCities);
  };

  const filter = async () => {
    let response = await TransactionAuditCities(
      cities[0],
      cities[1],
      cities[2],
      cities[3],
      cities[4]
    );
    let data = response.data.record;

    if (data.length != undefined) {
      setFilteredTransaction(data);
    } else {
      setFilteredTransaction([data]);
    }
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="compliance-filter-container-modal"
        style={{
          position: "fixed",
          zIndex: 9999,
          display: "flex",
        }}
      >
        <div className="centered-content">
          <div className="text-end">
            <img src={Close} onClick={handleClose} className="pointer" loading="lazy" />
          </div>
          <div className="high-crime-cities">
            <div className="modal-title text-center pb-3">Edit Query</div>
            <div className="text-center">
              <input
                type="text"
                placeholder="Enter a city..."
                value={newCity}
                onChange={(e) => setNewCity(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    addCity();
                  }
                }}
              />
            </div>

            <div className="mt-2 text-center">Please enter up to 5 cities</div>

            <div className="city-list text-center">
              {cities.map((city, index) => (
                <div
                  key={index}
                  className="city-item"
                  onClick={() => removeCity(city)}
                >
                  {city}
                  <span className="remove-city">x</span>
                </div>
              ))}
            </div>
            <div className="filter-submit">
              <div className="submit-button pointer" onClick={filter}>
                Submit
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default TransactionFilterModal;
